/* ══════════════════════════════════════
   LAYOUT — Sidebar + Main Wrapper
   Matches Licensing Dashboard exactly
   ══════════════════════════════════════ */

.layout {
  display: flex;
  min-height: 100vh;
  min-width: 0;
  max-width: 100%;
}

/* Main wrapper sits to the right of sidebar.
   `height`, not `min-height` — a min-height alone never bounds the column, so
   any page taller than the viewport grows the shell instead of scrolling
   inside it. Pages that want an app-like fixed frame (the workflow canvas: a
   pinned composer with an independently scrolling transcript) can only get one
   if the height is definite the whole way down. */
.mainWrapper {
  /* The collapsed rail is 60px. On hover it widens as an overlay (position:
     fixed) without reflowing the page, so the margin only needs to track the
     collapsed width — except when pinned, where the rail holds at 240px and the
     content must sit beside it. The transition matches the rail's own width
     animation (--duration-base) so the two move together. */
  margin-left: 60px;
  display: flex;
  flex-direction: column;
  height: 100vh;
  flex: 1;
  /* Without this a flex item keeps min-width:auto and refuses to shrink below
     its content, so wide page content pushes the whole shell past the viewport. */
  min-width: 0;
  transition: margin-left var(--duration-base) var(--ease-default);
}

.mainWrapper[data-sidebar-pinned] {
  margin-left: 240px;
}

/* Main content area with padding.
   `min-height: 0` lets this flex item shrink below its content, which is what
   makes .main the scroll container instead of the window. Long pages scroll
   here and behave as before — the sticky Header is a sibling above, so it
   stays put either way. */
.main {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 24px 32px;
  overflow-y: auto;
  overflow-x: hidden;
}
